import styled from "styled-components";

export const DashboardContainer = styled.div`
  display: flex;
  background-color: ${props => props.theme.white1};
  flex-direction: row;
  align-items: center;
  height: 100vh;
  overflow-y: hidden;
  
`;
export const ContentContainer = styled.div`
  justify-content: center;
  position: relative;
  width: 100%;
  height: 100%;
  min-width: 1570px;
  overflow: hidden;

`;

export const CalendarContainer = styled.div`
  height: calc(100% - 40px);
  position: relative;
  border: 1px solid ${props => props.theme.white4};
  margin: 20px;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  overflow-y: auto;
`;

export const HeaderContainer = styled.div`
  width: 1480px;
  top: 0px;
  background-color: ${props => props.theme.white1};
  position: sticky;
  display: flex;
  padding-top: 0px;
  padding-bottom: 0px;  
  justify-content: space-between;
`;

export const ControllContainer = styled.div`
`;

export const SelectContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Input = styled.input`
  font-size: 20px;
  width: 200px;
  height: 40px;
  padding: 0 10px;
  margin: 5px;
  margin-left: 60px;
  border-radius: 5px;
  border: 0;
  background-color: ${props => props.theme.white3};
  color: unset;

  &.date {
    width: 120px;
  }

  /* Chrome, Safari, Edge, Opera */
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  -moz-appearance: textfield;
  appearance: none;

  &:focus {
    outline: none;
  }
`;

export const SelectBar = styled.div`
  display: flex;
  align-items: center;

  img {
    cursor: pointer;
    margin-left: 20px;
  }
`;

export const HeaderViewContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const CalendarDiv = styled.div`
  width: 1480px;
  margin-top: 0px;
  height: calc(100% - 230px);
  overflow-x: hidden;
`;


export const InfoContainer = styled.div`
  margin-left: 30px;
  display: flex;
    flex-direction: column;
    justify-content: flex-end;
`;

export const InfoDiv = styled.div`
  width: 220px;
  height: 100px;
  margin: 20px 20px 0 0;
  padding: 15px 20px;
  background-color: ${props => props.theme.white0};
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid ${props => props.theme.white5};
  position: relative;
  border-radius: 7px;
  display: flex;
  flex-direction: column;
  align-items: center;
  span {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  p {
    font-size: 14px;
  }
  h4 {
    margin: 0 10px 0 10px;
    font-weight: 600;
  }
  span p {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
  }
`;

export const WeekInfoDiv = styled.div`
  width: 240px;
  margin: 20px 20px 0 0;
  padding: 15px 20px;
  background-color: ${props => props.theme.white0};
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #ddd;
  position: relative;
  border-radius: 7px;
  display: flex;
  flex-direction: column;
  align-items: center;
  div {
    display: flex;
    margin: 5px 0;
  }
`;

export const WeekdayContainer = styled.div`
  background-color: ${props => props.theme.white1};
  position: sticky;
  top: 70px;
  display: flex;
  justify-content: space-between;
  width: 1460px;
  padding: 10px 0;
  margin-left: 10px;
  span {
    font-size: 18px;
    width: 200px;
    text-align: center;
    font-weight: bold;
    background-color: ${props => props.theme.colorwhite0};
  }
`;
export const FooterContainer = styled.div`
  background-color: ${props => props.theme.white1};
  position: absolute;
  bottom: 20px;
  display: flex;
  justify-content: space-between;
  width: 1460px;
  margin-left: 10px;
  div{
    padding: 2px 20px;
    width: 200px;
    height: 90px;
    text-align: center;
    font-weight: bold;
    background-color: ${props => props.theme.colorwhite0};
  }
  h6, h5{
    margin: 2px;
  }
  span{
    display: flex;
    justify-content: space-between;
  }
  span p{
    font-size: 12px;
  }
`;

export const ListContainer = styled.div`
  min-width: 300px;
  width: calc(10% + 192px);
  border-left: 1px solid #ddd;
  margin: 20px 0px;
  background-color: ${props => props.theme.white1};
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  height: 100%;
  font-size: 20px;
  text-align: left;
`;
export const ListHeader = styled.div`
  padding: 20px;
  position: relative;
  display: flex;
`;

export const ListInfoContainer = styled.div`
  padding: 20px;
  position: relative;
  h3 {
    font-weight: 600;
  }
  p {
    font-weight: 600;
    margin: 0px
  }
  h4 {
    position: absolute;
    left: 130px;
    margin: 0;
  }
  span {
    margin: 10px 0;
    display: flex;
    align-items: center;
  }
`;